import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "plan-content p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "sm-fs-base" }, "Upload And Enter List of Employees ", -1)
const _hoisted_3 = {
  class: "position-fixed top-0 end-0 p-3",
  style: {"z-index":"11"}
}
const _hoisted_4 = { class: "d-flex flex-column gap-30 w-100" }
const _hoisted_5 = {
  key: 0,
  class: "bordered-card bordered-card_secondary"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "sm-fs-base" }, "Upload Documents", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  class: "w-100 d-flex flex-column gap-15"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-semibold" }, [
  /*#__PURE__*/_createTextVNode("Uploaded - "),
  /*#__PURE__*/_createElementVNode("span", null, " files")
], -1)
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-trash icon_delete plan-modal" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "bordered-card bordered-card_secondary"
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<h2 class=\"sm-fs-base\">Employees </h2><label class=\"sm-fs-sm\"> # SSN <span class=\"text-danger\">*</span><span class=\"tooltip-wrapper tooltip-wrapper_secondary\" data-tooltip=\"Social Security Number should be 9 digit numeric only. After entry of an SSN hit Enter or click the ‘Add\n                        Another Employee’ button to enter the next SSN\"><i class=\"iatse-icon-info-circle pdl-10\"></i></span></label>", 2)
const _hoisted_18 = {
  key: 0,
  class: "btn-delete"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "w-100 d-flex align-items-center flex-md-row flex-column justify-content-between gap-4 sm-mb-100" }
const _hoisted_21 = { class: "d-flex gap-4 w-sm-100" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "d-flex gap-4 w-sm-100 sm-mb-20" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_DragDrop = _resolveComponent("DragDrop")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("div", { class: "alert alert-success" }, _toDisplayString(_ctx.success), 513), [
          [_vShow, _ctx.success]
        ]),
        _withDirectives(_createElementVNode("div", { class: "alert alert-danger" }, _toDisplayString(_ctx.error), 513), [
          [_vShow, _ctx.error]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SelectComponent, {
          label: "Year of Coverage (Required, Applies to Enter Form)",
          selectedOption: _ctx.year,
          "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year) = $event)),
          options: _ctx.years
        }, null, 8, ["selectedOption", "options"]),
        (_ctx.ssnOption === '0')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("small", null, [
                _createTextVNode(" There is only one acceptable Excel file format. It must contain a single column with \"SSN\" as the header. "),
                _hoisted_7,
                _createTextVNode(" Each SSN must be in number format with hyphens (No other special characters or space) and must contain 9 digits."),
                _hoisted_8,
                _createTextVNode(" For Example: XXX-XX-XXXX. Click "),
                _createElementVNode("a", {
                  href: _ctx.excelModel,
                  target: "_blank"
                }, "here", 8, _hoisted_9),
                _createTextVNode(" for sample format. ")
              ]),
              _createVNode(_component_DragDrop, {
                accept: ".xlsx, .csv",
                customClasses: "blue large w-100",
                onChange: _ctx.handleFileSelection,
                browseText: "Browse",
                icon: "iatse-icon-Upload-icon",
                key: "drag-drop-aca",
                reset: _ctx.reset,
                onReset: _ctx.handleReset,
                loading: _ctx.loading
              }, null, 8, ["onChange", "reset", "onReset", "loading"]),
              (_ctx.loading || _ctx.fileHashes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileHashes, (fileHash, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "bordered-card bordered-card_secondary flex-row fs-xs align-items-center p-2"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(fileHash), 1),
                        _createElementVNode("div", {
                          class: "btn-delete small plan-modal",
                          onClick: ($event: any) => (_ctx.handleDelete(index))
                        }, _hoisted_14, 8, _hoisted_12)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ssnList, (ssn, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex gap-4 align-items-center w-100"
                }, [
                  _createVNode(_component_TextInput, {
                    type: "text",
                    name: "ssn",
                    max: 11,
                    modelValue: _ctx.ssnList[index],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.ssnList[index]) = $event),
                    "is-required": true,
                    pattern: "\\d{3}-\\d{2}-\\d{4}",
                    placeholder: "***-**-****",
                    onKeyup: _withKeys(_ctx.addAnotherEmployee, ["enter"]),
                    "custom-class": "w-100"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"]),
                  (index > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("i", {
                          class: "iatse-icon-trash icon_delete plan-modal fs-4",
                          onClick: ($event: any) => (_ctx.deleteEmployee(index))
                        }, null, 8, _hoisted_19)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addAnotherEmployee && _ctx.addAnotherEmployee(...args)))
              }, "Add Another Employee")
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          class: "btn btn-secondary w-sm-100",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args))),
          disabled: _ctx.loading || _ctx.deleting
        }, "Back", 8, _hoisted_22)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", {
          class: "btn btn-secondary w-sm-100",
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args)), ["prevent"])),
          disabled: _ctx.loading || _ctx.deleting
        }, "Cancel", 8, _hoisted_24),
        _createElementVNode("button", {
          class: "btn btn-secondary w-sm-100",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args))),
          disabled: _ctx.loading
        }, _toDisplayString(_ctx.submitting ? 'Submitting...' : 'Submit Request'), 9, _hoisted_25)
      ])
    ])
  ], 64))
}